<template>
  <div class="relative">
    <RevButtonIcon
      :aria-label="i18n(translations.cartIconAltText)"
      :icon="IconShoppingBag"
      :title="i18n(translations.cartIconAltText)"
      :to="resolveLocalizedRoute({ name: CHECKOUT.CART })"
      variant="ghost"
      @click="
        trackClick({
          zone: 'header',
          name: 'cart',
        })
      "
    />
    <span
      v-if="cartBadgeCount > 0"
      class="bg-action-danger-hi text-onaction-default-hi rounded-full label-small-bold pointer-events-none absolute right-3 top-3 box-content flex h-16 w-16 items-center justify-center border-1"
      data-test="cart-badge"
      >{{ cartBadgeCount }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { useNuxtApp, useRouteLocationWithLocale } from '#imports'
import { computed, onMounted } from 'vue'

import { useBuybackEnabled } from '@backmarket/nuxt-layer-buyback/app/composables/useBuybackEnabled/useBuybackEnabled'
import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/composables/useBuybackOffer/useBuybackOffer'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './CartIcon.translations'

const { user, fetchUser } = useUserStore()
const { hasBuybackOffer } = useBuybackOffer()
const { isRegularTradeInEnabled } = useBuybackEnabled()

// A trade-in alone in the cart (swap only cart) counts as one item
const cartBadgeCount = computed(() => {
  if (user.value.cartItemsCount > 0) return user.value.cartItemsCount

  return isRegularTradeInEnabled && hasBuybackOffer.value ? 1 : 0
})

const i18n = useI18n()

const { trackClick } = useTracking()
const resolveLocalizedRoute = useRouteLocationWithLocale()

// TODO: [CK-3730] Remove this fetch and let the cart page update the cartItemsCount directly (as done in pastrami)
// The user is already fetched in the user plugin on the first load
// We don't need to fetch it again.
// However, we can refresh the user data on next client-side navigation
// (e.g after the user navigates back from the cart page to the home page)
const nuxtApp = useNuxtApp()
if (!nuxtApp.isHydrating) {
  onMounted(async () => {
    await fetchUser()
  })
}
</script>
